module.exports = __webpack_public_path__ + "media/images/upload-example-4-9bf2aca9af96465a611e9f06d5e96d05.png";